// extracted by css-extract-rspack-plugin
export default {"root":"root-ennDRe","skeleton":"skeleton-EkGvZm","image":"image-XyqQ3F","hidden":"hidden-cwPGbK"};